import React from "react";
import Box from "react-raster";
import { CommentView, Heading } from "src/components";
import { theme } from "src/config";
import { Colors } from "src/types";

export const CommentSection = () => {
  const [date, setDate] = React.useState(0);

  return (
    <Box>
      <Box
        colspan={2}
        gridColumnGap={theme.layout.gutterSmall}
        gridRowGap={theme.layout.gutterSmall}
      >
        <Box cols={2}>
          <hr />
        <Heading weight="normal" type="h3" color="black">
        </Heading>
        </Box>
        {/* <Comments /> */}
      </Box>
    </Box>
  );
};
